<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

  <button
    type="button"
    sb-button-primary
    color="blau"
    sbTooltip="{{ 'lang.admin.licenceManagement.load' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'upload'"
    (click)="openLoadLicencesModal()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.admin.licenceManagement.download' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'download'"
    (click)="downloadCSV()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

  <button
    type="button"
    sb-button-primary
    color="red"
    sbTooltip="{{ 'lang.admin.licenceManagement.unassignAll' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'linkNone'"
    (click)="unAssignAll()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

  <button
    type="button"
    sb-button-primary
    color="green"
    sbTooltip="{{ 'lang.admin.licenceManagement.autoAssign' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'link'"
    (click)="autoAssignAll()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

  <button
    type="button"
    sb-button-primary
    color="green"
    sbTooltip="{{ 'lang.admin.licenceManagement.create.plural' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'plus'"
    (click)="openGenerateLicencesModal()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<!------------------------------

    Table wrapper

------------------------------->
<sb-table-wrapper-new
  headline="{{'lang.admin.licenceManagement' | translate}}"
  [itemsData]="licences"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'licences'">

  <!------------------------------

      Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>
      </th>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.createdAt' | translate }}
      </th>
      <th>
        {{ 'lang.admin.licenceManagement.table.uuid' | translate }}
      </th>
      <th>
        {{ 'lang.globals.type' | translate }}
      </th>
      <th>
        {{ 'lang.admin.licenceManagement.table.usage' | translate }}
      </th>
      <th>
        {{ 'lang.admin.licenceManagement.table.application' | translate }}
      </th>
      <th>
        {{ 'lang.admin.licenceManagement.table.domain' | translate }}
      </th>
      <th></th>
    </tr>
  </ng-template>
  <!------------------------------

Table Body

------------------------------->
  <ng-template #tbody let-licence>
    <tr>
      <td>
        @if (licence?.inUse) {
          <sb-icon icon="success" class="green"></sb-icon>
        } @else {
          <sb-icon icon="error" class="red"></sb-icon>
        }
      </td>
      <td>
        {{ licence?.id }}
      </td>
      <td>
        {{ licence?.name }}
      </td>
      <td>
        {{ licence?.createdAt | date: 'dd.MM.yy HH:mm:ss' }}
      </td>
      <td>
        {{ licence?.uuid }}
      </td>
      <td>
        {{ licence?.type }}
      </td>
      <td>
        {{ licence?.configuration }}
      </td>
      <td>
        {{ licence?.application }}
      </td>
      <td>
        {{ licence?.domain }}
      </td>
      <td class="sticky-col last-col">
        <div class="tw-flex tw-gap-2.5">
          <sb-split-button
            [splitButtonItems]="licence.extraSbButtons ?? []"
            (selectedAction)="resolveSplitButtonAction(licence, $event)"
          ></sb-split-button>
          <sb-split-button
            [splitButtonItems]="licence.sbButtons ?? []"
            (selectedAction)="resolveSplitButtonAction(licence, $event)"
          ></sb-split-button>
        </div>
      </td>
    </tr>
  </ng-template>
  <!------------------------------

    Card Element

------------------------------->
  <!-- No card element -->

</sb-table-wrapper-new>
